import React from 'react';
import LoadingTie from './LoadingTie';

const DeviationMissingValuesTie = props => {
    return (
        <div className="card card-default" style={{height: '100%'}} id="deviationMissingValues">
            <div className="card-body text-center">
                {props.deviation_missing.missingValues ? (
                    <>
                        <h4>Number of missing values</h4>
                        <br />
                        <h3>{props.deviation_missing.missingValues}</h3>
                    </>
                ) : (
                    <LoadingTie />
                )}
            </div>
        </div>
    );
};

export default DeviationMissingValuesTie;
